import React, { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import { damga, yazdirBaslikli } from "../lib/stamp";
import { Printer, Download, RefreshCw } from "lucide-react";

const VARDIYA = ["00:00 - 08:00", "08:00 - 16:00", "16:00 - 24:00"];
const today = () => new Date().toISOString().slice(0, 10);
const fmt = (n) => (n == null ? "0" : Number(n).toLocaleString("tr-TR"));
const trTarih = (s) => {
  if (!s) return "";
  const p = String(s).slice(0, 10).split("-");
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : s;
};
const esc = (v) => String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export default function PlanlamaOneri() {
  const [tarih, setTarih] = useState(today());
  const [vardiya, setVardiya] = useState(VARDIYA[2]);
  const [data, setData] = useState({ groups: [], genel_toplam: 0 });
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    api.get("/planlama/oneri-plan", { params: { tarih, vardiya } })
      .then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const exportExcel = () => {
    let body = `<tr><td colspan="7" style="background:#A9D08E;font-weight:bold;text-align:center;">TARİH: ${esc(trTarih(tarih))}&nbsp;&nbsp;ÜRETİM PLANLAMA&nbsp;&nbsp;VARDİYA: ${esc(vardiya)}</td></tr>`;
    body += `<tr style="background:#E9E9E9;font-weight:bold;"><th>ÜRÜN KODU</th><th>FIRIN BÖLGESİ</th><th>KALIP KODU</th><th>RENK</th><th>ADET</th><th>LOGO</th><th>İŞ BÖLÜMÜ</th></tr>`;
    (data.groups || []).forEach((g) => {
      g.rows.forEach((r) => {
        body += `<tr><td>${esc(r.urun_kodu)}</td><td>${esc(g.firin_bolgesi)}</td><td>${esc(r.kalip_kodu)}</td><td>${esc(r.renk)}</td><td>${r.adet}</td><td></td><td>${esc(r.is_bolumu)}</td></tr>`;
      });
      body += `<tr style="background:#FFFF00;font-weight:bold;"><td></td><td></td><td></td><td>ARA TOPLAM</td><td>${g.ara_toplam}</td><td></td><td></td></tr>`;
    });
    body += `<tr style="background:#A9D08E;font-weight:bold;"><td></td><td></td><td></td><td>GENEL TOPLAM</td><td>${data.genel_toplam}</td><td></td><td></td></tr>`;
    const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body><table border="1">${body}</table></body></html>`;
    const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `Üretim Planlama - ${tarih} - ${damga()}.xls`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <PageHeader
        title="Planlama Öneri"
        subtitle="Bisküvisi olan ürünler için termin önceliğine göre otomatik üretim planlama önerisi"
        actions={
          <div className="flex items-center gap-2">
            <button onClick={exportExcel} data-testid="export-btn"
              className="flex items-center gap-2 border border-zinc-300 hover:bg-zinc-50 text-zinc-700 text-sm font-semibold px-3 py-2 rounded-sm">
              <Download size={15} /> Excel'e Aktar
            </button>
            <button onClick={() => yazdirBaslikli("Planlama Öneri")} data-testid="print-btn"
              className="flex items-center gap-2 border border-zinc-300 hover:bg-zinc-50 text-zinc-700 text-sm font-semibold px-3 py-2 rounded-sm">
              <Printer size={15} /> PDF / Yazdır
            </button>
          </div>
        }
      />
      <div className="p-6 space-y-4">
        <div className="border border-zinc-200 bg-white rounded-sm p-4 flex items-end gap-2 flex-wrap no-print">
          <div>
            <label className="block text-[10px] font-semibold text-zinc-500 uppercase mb-0.5">Tarih</label>
            <input type="date" value={tarih} onChange={(e) => setTarih(e.target.value)} data-testid="plan-tarih"
              className="border border-zinc-300 rounded-sm px-2 py-1.5 text-sm mono" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-zinc-500 uppercase mb-0.5">Vardiya</label>
            <select value={vardiya} onChange={(e) => setVardiya(e.target.value)} data-testid="plan-vardiya"
              className="border border-zinc-300 rounded-sm px-2 py-1.5 text-sm">
              {VARDIYA.map((v) => <option key={v} value={v}>{v}</option>)}
            </select>
          </div>
          <button onClick={load} data-testid="plan-refresh-btn"
            className="flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold px-4 py-1.5 rounded-sm">
            <RefreshCw size={14} /> Öneri Oluştur
          </button>
        </div>

        <div className="print-area border-2 border-zinc-800 bg-white overflow-x-auto" data-testid="plan-sheet">
          <div className="bg-green-200 text-center font-head font-black text-lg py-2 border-b-2 border-zinc-800">
            TARİH: {trTarih(tarih)} &nbsp;&nbsp; ÜRETİM PLANLAMA &nbsp;&nbsp; VARDİYA: ({vardiya})
          </div>
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="bg-zinc-100 font-bold text-center">
                <th className="border border-zinc-400 px-2 py-1.5">ÜRÜN KODU</th>
                <th className="border border-zinc-400 px-2 py-1.5">FIRIN BÖLGESİ</th>
                <th className="border border-zinc-400 px-2 py-1.5">KALIP KODU</th>
                <th className="border border-zinc-400 px-2 py-1.5">RENK</th>
                <th className="border border-zinc-400 px-2 py-1.5">ADET</th>
                <th className="border border-zinc-400 px-2 py-1.5">LOGO</th>
                <th className="border border-zinc-400 px-2 py-1.5">İŞ BÖLÜMÜ</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={7} className="text-center py-10 text-zinc-400">Öneri hazırlanıyor...</td></tr>
              ) : (data.groups || []).length === 0 ? (
                <tr><td colSpan={7} className="text-center py-10 text-zinc-400">Bisküvisi olan bekleyen sipariş bulunamadı.</td></tr>
              ) : data.groups.map((g) => (
                <React.Fragment key={g.firin_bolgesi}>
                  {g.rows.map((r, i) => (
                    <tr key={i} data-testid={`plan-row-${r.kalip_kodu}`}>
                      <td className="border border-zinc-400 px-2 py-1 mono">{r.urun_kodu}</td>
                      {i === 0 && (
                        <td rowSpan={g.rows.length + 1} className="border border-zinc-400 px-2 py-1 text-center font-bold align-middle bg-zinc-50">
                          {g.firin_bolgesi}
                        </td>
                      )}
                      <td className="border border-zinc-400 px-2 py-1 mono">{r.kalip_kodu}</td>
                      <td className="border border-zinc-400 px-2 py-1">{r.renk || ""}</td>
                      <td className="border border-zinc-400 px-2 py-1 num text-center font-semibold">{fmt(r.adet)}</td>
                      <td className="border border-zinc-400 px-2 py-1"></td>
                      <td className="border border-zinc-400 px-2 py-1 text-center">{r.is_bolumu || ""}</td>
                    </tr>
                  ))}
                  <tr className="bg-yellow-300 font-bold" data-testid={`ara-toplam-${g.firin_bolgesi}`}>
                    <td className="border border-zinc-400 px-2 py-1"></td>
                    <td className="border border-zinc-400 px-2 py-1"></td>
                    <td className="border border-zinc-400 px-2 py-1 text-right">ARA TOPLAM</td>
                    <td className="border border-zinc-400 px-2 py-1 num text-center">{fmt(g.ara_toplam)}</td>
                    <td className="border border-zinc-400 px-2 py-1"></td>
                    <td className="border border-zinc-400 px-2 py-1"></td>
                  </tr>
                </React.Fragment>
              ))}
              {(data.groups || []).length > 0 && (
                <tr className="bg-green-200 font-black text-base">
                  <td className="border border-zinc-400 px-2 py-2"></td>
                  <td className="border border-zinc-400 px-2 py-2"></td>
                  <td className="border border-zinc-400 px-2 py-2"></td>
                  <td className="border border-zinc-400 px-2 py-2 text-right">GENEL TOPLAM</td>
                  <td className="border border-zinc-400 px-2 py-2 num text-center">{fmt(data.genel_toplam)}</td>
                  <td className="border border-zinc-400 px-2 py-2"></td>
                  <td className="border border-zinc-400 px-2 py-2"></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
